import { Router } from "react-router-dom"
import { Provider } from "react-redux"

import AppRoutes from "routes"
import store from "store"
import "./global.scss"
import { ToastContainer } from "react-toastify"
import { useLayoutEffect, useState } from "react"
import { createBrowserHistory } from "history"

export const history = createBrowserHistory()

const basepath = "/"

export const pushWithBasePath = (path: string) => {
  // const newPath = `${basepath}${path}`

  history.push(path)
  // if (basepath === "/") {
  // } else {
  //   history.push(newPath)
  // }
}

const CustomBrowserRouter = ({ children }: { children: React.ReactNode }) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  })

  useLayoutEffect(() => history.listen(setState), [])

  return (
    <Router
      location={state.location}
      navigator={history}
      navigationType={state.action}
      basename={basepath}
    >
      {children}
    </Router>
  )
}

const App = () => (
  <Provider store={store}>
    <CustomBrowserRouter>
      <AppRoutes />
    </CustomBrowserRouter>
    <ToastContainer />
  </Provider>
)

export default App
